module.exports = __webpack_public_path__ + "img/colorful3-start.bb775cf0.png";